<style lang="scss">
  @import "@/assets/scss/vuexy/pages/Map.scss";
  @import "~leaflet.markercluster/dist/MarkerCluster.css";
  @import "~leaflet.markercluster/dist/MarkerCluster.Default.css";
</style>
<template>
    <div class="item-grid-view vx-row match-height mt-4">
        <div class="vx-col w-full">
            <vx-card class="grid-view-item overflow-hidden">
                <div id="container-map" v-if="status_mapa">
                    <l-map :center="center" :zoom="10" ref="mymap" style="height: 100%; overflow: hidden;">
                        <l-control-layers :collapsed="true" :position="layersPosition" :sort-layers="true">
                        </l-control-layers>
                        <l-tile-layer :key="tileProvider.name" :name="tileProvider.name" :url="tileProvider.url" :visible="tileProvider.visible" layer-type="base" v-for="tileProvider in tileProviders">
                        </l-tile-layer>
                        <v-marker-cluster>
                            <l-marker :draggable="item.draggable" :key="item.id" :lat-lng.sync="item.position" :visible="item.visible" v-for="item in markers">
                                <l-icon :icon-anchor="staticAnchor">
                                    <img :src="require(`@/assets/images/markers/${item.status}.svg`)" width="17px;"/>
                                </l-icon>
                                <l-popup>
                                    <div class="popup">

                                      <gridPrincipalItem
                                        img="co2"
                                        :name="item.alias"
                                        :description="$t('Labels.Alias')"
                                      ></gridPrincipalItem>
                                      <vs-divider/>
                                      <valueItem
                                        :value="item.ppm"
                                        :description="$t('Labels.Co2')"
                                        img="co2"
                                        unit="ppm"
                                      />
                                      <valueItem
                                        :value="item.temperature"
                                        :description="$t('Labels.Temperature')"
                                        img="temperature"
                                        unit="°C"
                                      />
                                      <valueItem
                                        :value="item.humidity"
                                        :description="$t('Labels.Humidity')"
                                        img="humedad"
                                        unit="%"
                                      />
                                      <alertRelay :status="item.relay1_state === '1'? true: false" name="Relay 1" />
                                      <alertRelay :status="item.relay2_state === '1'? true: false" name="Relay 2" />
                                      <vs-divider/>
                                      <valueItem
                                        :value="item.updated_at.split(' ')[0]"
                                        :description="item.updated_at.split(' ')[1]"
                                        img="fecha"
                                      ></valueItem>

                                    <div class="text-center"><vs-button color="primary"  size="small" @click="deviceInformation(item.id)">Ver Más</vs-button></div>

                                </div>
                                </l-popup>
                            </l-marker>
                        </v-marker-cluster>
                         <LeafletHeatmap :lat-lngs="ppmData" :max="5000" :radius="25" v-if="ppmData.length > 0 && status_heat"></LeafletHeatmap>
                    </l-map>
                </div>
            </vx-card>
        </div>
    </div>
</template>
<script>
import {
  LMap,
  LTileLayer,
  LMarker,
  LIcon,
  LPopup,
  LControlLayers
} from 'vue2-leaflet'
import Vue2LeafletMarkercluster from 'vue2-leaflet-markercluster/Vue2LeafletMarkercluster'
import gridPrincipalItem from '@/components/gridPrincipalItem/gridPrincipalItem.vue'
import valueItem from '@/components/valueItem/valueItem.vue'
import alertRelay from '@/components/alertRelay/alertRelay.vue'
import { request } from '@/request.js'
import 'leaflet/dist/leaflet.css'
import 'leaflet-fullscreen/dist/leaflet.fullscreen.css'
import 'leaflet-fullscreen/dist/Leaflet.fullscreen'
import LeafletHeatmap from '@/components/Vue2LeafletHeatmap.vue'
/* global L:true */

const tileProviders = [
  {
    name: 'Gris',
    visible: true,
    url: 'https://cartodb-basemaps-{s}.global.ssl.fastly.net/light_all/{z}/{x}/{y}.png'
  },
  {
    name: 'Calles',
    visible: false,
    url: 'https://{s}.tile.openstreetmap.fr/osmfr//{z}/{x}/{y}.png'
  },
  {
    name: 'Satelite',
    visible: false,
    url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}.png'
  }
]

export default {
  name: 'mapa',
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LPopup,
    LIcon,
    LControlLayers,
    'v-marker-cluster': Vue2LeafletMarkercluster,
    gridPrincipalItem,
    valueItem,
    alertRelay,
    LeafletHeatmap
  },
  data () {
    return {
      response: [],
      tileProviders,
      layersPosition: 'topright',
      center: [20.662396323989693, -103.37640969334421],
      staticAnchor: [12, 27],
      markers: [],
      status_mapa: false,
      status_heat: false,
      ppmData: []
    }
  },
  methods: {
    async getMapa () {
      this.$vs.loading()
      const params = {
        url: 'co2_devices/mapa/list',
        method: 'GET'
      }
      await request(params).then(data => {
        data = data.data.data
        const positions = []
        this.ppmData = []
        for (let i = 0; i < data.length; i++) {
          const [lat, lng] = data[i].latlong.split(',')
          positions.push([lat, lng])
          this.ppmData.push([lat, lng, data[i].ppm_current])
          this.markers.push({
            position: { lat: lat, lng: lng },
            alias: data[i].alias,
            status: data[i].status,
            updated_at: data[i].updated_at,
            id: data[i].uuid,
            humidity: parseFloat(data[i].hum_current || 0).toFixed(2),
            temperature: parseFloat(data[i].temp_current || 0).toFixed(2),
            ppm: parseFloat(data[i].ppm_current || 0).toFixed(2),
            relay1_state: data[i].relay1_state,
            relay2_state: data[i].relay2_state,
            draggable: false,
            visible: true
          })
        }

        this.status_mapa = true
        this.status_heat = true

        const app = this
        setTimeout(function () {
          const maps = app.$refs.mymap.mapObject
          maps.addControl(new L.Control.Fullscreen())
          maps.fitBounds(positions)
        }, 1000)
      }).catch(() => {
        this.markers = []
      }).finally(() => {
        this.$vs.loading.close()
      })
    },

    deviceInformation (uuid) {
      window.location.href = `/co/detail/${uuid}`
    }

  },
  sockets: {
    co2 (payload) {
      this.ppmData = []
      this.markers.forEach(markerToModify => {
        if (markerToModify.id === payload.uuid) {
          markerToModify.humidity = parseFloat(payload.hum_current || 0).toFixed(2)
          markerToModify.temperature = parseFloat(payload.temp_current || 0).toFixed(2)
          markerToModify.ppm = parseFloat(payload.ppm_current || 0).toFixed(2)
          markerToModify.relay1_state = payload.relay1_state
          markerToModify.relay2_state = payload.relay2_state
        }
        this.ppmData.push([markerToModify.position.lat, markerToModify.position.lng, markerToModify.ppm])
      })
    }
  },

  created () {
    this.getMapa()
  }

}
</script>
